import { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import Providers from "./providers/Providers";

const App = (): JSX.Element => {
  useEffect(() => {
    localStorage.setItem("chakra-ui-color-mode", "dark");
  }, []);

  return (
    <Providers>
      <AppRoutes />
    </Providers>
  );
};

export default App;
